import { create } from 'zustand';
import { api } from '@/lib/apiClient';

function convertToArray(str) {
    if (!str) return [];
    return str.split('-').map(num => parseInt(num, 10));
}

export const useCityStore = create((set, get) => ({
    // State
    cities: [],
    localities: [],
    selectedCity: null,
    selectedLocalities: [],
    localitiesIds: [],
    citySearch: '',
    localitySearch: '',
    isLoading: false,

    // Simple setters
    setCitySearch: (citySearch) => set({ citySearch }),
    setLocalitySearch: (localitySearch) => set({ localitySearch }),
    setSelectedCity: (selectedCity) => set({ selectedCity }),
    setSelectedLocalities: (selectedLocalities) => set({ selectedLocalities }),
    addLocality: (locality) => set((state) => ({
        selectedLocalities: [...state.selectedLocalities, locality],
    })),
    removeLocality: (idToRemove) => set((state) => ({
        selectedLocalities: state.selectedLocalities.filter(l => l.id !== idToRemove),
    })),
    removeLastLocality: () => set((state) => ({
        selectedLocalities: state.selectedLocalities.slice(0, -1),
    })),

    // Async: Fetch localities for a given city
    fetchLocalities: async (cityId, initialLocalities = []) => {
        try {
            const res = await api.post('selectwithout/master_localities', {
                sqlData: "locality_name as name, id, slug",
                where: "city_id=$1 and is_active=$2 order by name asc",
                whereData: [cityId, true],
            });
            if (res.success === 1 && Array.isArray(res.data)) {
                const newState = { localities: res.data, localitySearch: '' };
                if (res.data.length > 0 && initialLocalities.length > 0) {
                    const matched = res.data.filter(l => initialLocalities.includes(l.id));
                    newState.selectedLocalities = matched.length > 0 ? matched : [];
                } else {
                    newState.selectedLocalities = [];
                }
                set(newState);
            }
        } catch (error) {
            console.error('Error fetching localities:', error);
        }
    },

    // Async: Fetch cities and auto-select based on URL params
    fetchCities: async (cityIdParam, localitiesParam) => {
        set({ isLoading: true });
        try {
            const localities = convertToArray(localitiesParam);
            set({ localitiesIds: localities });
            console.log("cityId: " + cityIdParam);
            console.log("localitiesIds: " + localities);

            const response = await api.post('selectwithout/view_home_cities', {
                sqlData: "*",
                where: "is_active=$1 order by id asc",
                whereData: [true],
            });

            if (response.success === 1 && Array.isArray(response.data)) {
                set({ cities: response.data });

                if (response.data.length > 0) {
                    const { fetchLocalities } = get();

                    if (cityIdParam) {
                        const city = response.data.find(c => c.id === parseInt(cityIdParam));
                        if (city) {
                            set({ selectedCity: city, citySearch: city.name });
                            fetchLocalities(city.id, localities);
                        }
                    } else {
                        const firstCity = response.data[0];
                        set({ selectedCity: firstCity, citySearch: firstCity.name });
                        fetchLocalities(firstCity.id, localities);
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching cities:', error);
        } finally {
            set({ isLoading: false });
        }
    },
}));